import { useState } from 'react';
import { Modal } from 'antd';
import { useLazyQuery } from '@apollo/client/react';

import QueryResult from 'components/QueryResult/QueryResult';
import HighlightHTML from 'components/HighlightHTML/HighlightHTML';
import useModalControls from 'hooks/useModalControls';
import { CUSTOMER_RECORD_DOCUMENT } from 'queries/comms';
import { formatDateTime } from 'utilities/datesAndTimes';

const CommunicationEvent = ({ event, highlight }) => {
  const eventDetailModal = useModalControls();

  const [getDocument, documentQuery] = useLazyQuery(CUSTOMER_RECORD_DOCUMENT);

  const showModal = () => {
    getDocument({
      variables: { documentId: event.documentId },
    });
    eventDetailModal.show();
  };

  const documentText = documentQuery.data?.commCustomerIoDocument?.body || '';
  const date = formatDateTime(event.sentDate);

  return (
    <div className="fs-exclude" data-testid="account-history-event">
      <div>{date}</div>
      <a role="button" onClick={showModal}>
        <HighlightHTML
          data-testid="account-history-communication"
          html={event.body}
          textToHighlight={highlight}
        />
      </a>
      <Modal
        {...eventDetailModal}
        cancelButtonProps={{ hidden: true }}
        className="fs-exclude"
        title={`${event.communicationType}: ${date}`}
        width={650}
      >
        <QueryResult {...documentQuery}>
          <div dangerouslySetInnerHTML={{ __html: documentText }} />
        </QueryResult>
      </Modal>
    </div>
  );
};

export default CommunicationEvent;
